import Swiper from 'swiper';
import './_js-banner-slider.scss'

$(function () {
	$('.js-banner-slider').each(function(){
		const $sliderWrapper = $(this);

		new Swiper($sliderWrapper.find('.swiper-container'), {
			loop: true,
			speed: 700,
			spaceBetween: 30,
			lazy: true,
			navigation: {
				nextEl: $sliderWrapper.find('.swiper-button-next'),
				prevEl: $sliderWrapper.find('.swiper-button-prev')
			},
			pagination: {
				el: $sliderWrapper.find('.swiper-pagination'),
				clickable: true
			},
			breakpoints: {
				900: {
					spaceBetween: 15
				}
			}
		});
	});
});
